<template>
  <img
    :src="`${mixinEnvironnement_damPath}/jel/${getUrlGifCourant(content.image)}`"
    :alt="content.image['@name']"
  />
</template>

<script>
import { mixinEnvironnement } from '@/mixins/mixinEnvironnement';

export default {
  name: 'MediaImageGif',
  mixins: [mixinEnvironnement],
  props: { content: { type: Object, required: true } },
  methods: {
    getUrlGifCourant(url) {
      if (!url?.length > 0) return '';
      const urlSplit = url.split('/');
      if (!urlSplit?.length > 0) return '';
      return urlSplit[urlSplit.length - 1];
    },
  },
};
</script>
